<template>
  <div class="projects">
    <div v-if="tab == 'Lists'" style="height: 99%">
      <ul class="shortcuts__lists" v-if="shortcuts.length > 0">
        <li v-for="(shortcut, i) in shortcuts" :key="i" :class="shortcut.type">
          <router-link
            :to="
              shortcut.type == 'inbox'
                ? '/inbox/' + getUserData.shortcut_inbox
                : '/shortcuts/' + shortcut.type
            "
          >
            <ShortcutsIcon :type="shortcut.type"></ShortcutsIcon>
            <div class="project_name_body no_messages">
              <div class="project_name">
                {{
                  enumShortcuts[
                    shortcut.type[0].toUpperCase() +
                      shortcut.type
                        .replaceAll("_", " ")
                        .replace(shortcut.type[0], "")
                  ]
                }}
              </div>
            </div>
          </router-link>
        </li>
      </ul>

      <NotFound
        text="No lists so far"
        v-if="lists.length == 0 && folders.length == 0 && shortcuts.length == 0"
      />

      <ul class="lists" v-else>
        <draggable
          :list="lists"
          @change="changeLists"
          group="list"
          v-bind="dragOptions"
          class="lists_block"
        >
          <li
            v-for="(project, i) of lists"
            :key="i"
            :ref="'project_' + project._id"
            @contextmenu.prevent="listContextMenu(project, true, $event)"
          >
            <router-link
              :to="linkLists(project._id)"
              v-if="
                project._id != getUserData.shortcut_inbox && !project.folder
              "
              class="li"
              :data-list-id="project._id"
            >
              <div
                style="display: flex; align-items: center"
                class="list_body-content"
              >
                <div
                  v-if="getUserData.theme"
                  class="project_icon"
                  :style="
                    'background-color: ' +
                    $shiftPaletteHue(
                      project.color,
                      '#cb4646',
                      getUserData.theme.color
                    )
                  "
                >
                  {{ project.name[0] }}
                </div>
                <ShortcutsIcon></ShortcutsIcon>
                <div
                  class="project_name_body"
                  :data-id="project._id"
                  @dragover="onDragBgColor($event)"
                  @drop="onDragOver(project._id, $event)"
                  :class="
                    get_unreaded_messages_in_project[project._id] > 0
                      ? ''
                      : 'no_messages'
                  "
                >
                  <div class="project_name" v-if="!project.rename">
                    {{ project.name }}
                  </div>
                  <div class="project_name" v-else>
                    <input
                      type="text"
                      v-model="project.name"
                      @keypress.enter="changeNameList(project)"
                      @blur="changeNameList(project)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="get_unreaded_messages_in_project[project._id] > 0"
                class="unread"
              >
                <p
                  v-if="
                    getListsMentions[project._id] &&
                    getListsMentions[project._id].mentions > 0
                  "
                  class="unread__mention"
                >
                  @
                </p>
                <p class="unread__count">
                  {{ unreaded_msg[project._id] }}
                </p>
              </div>
            </router-link>
          </li>
        </draggable>

        <draggable
          :list="folders"
          @change="changeLists"
          group="folder"
          v-bind="dragOptions"
          class="folder__lists"
        >
          <li
            v-for="(project, i) of folders"
            :key="i"
            :ref="'project_' + project._id"
            @contextmenu.prevent="listContextMenu(project, false, $event)"
          >
            <div
              class="folder"
              v-if="project.folder"
              :class="project.open ? 'active' : ''"
            >
              <div
                class="folder__flex"
                @click.prevent="openFolder(project._id)"
              >
                <p v-if="project.name != '' && !project.rename">
                  {{ project.name }}
                </p>
                <input
                  type="text"
                  maxlength="18"
                  v-else-if="project.rename"
                  @keypress.enter="changeNameFolder(project)"
                  v-model="project.name"
                  @blur="changeNameFolder(project)"
                />
                <input
                  type="text"
                  maxlength="18"
                  v-else
                  @keypress.enter="createFolder(project)"
                  v-model="folder_name"
                  @blur="blurFolderInput(project._id)"
                />
                <svg
                  width="9"
                  height="5"
                  viewBox="0 0 9 5"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.576117 0.99729C0.70958 0.997029 0.838921 1.04351 0.941688 1.12867L4.00335 3.68766L7.07071 1.22006C7.12914 1.17261 7.19637 1.13718 7.26854 1.1158C7.3407 1.09442 7.41638 1.08751 7.49122 1.09547C7.56607 1.10343 7.6386 1.12611 7.70465 1.16219C7.77071 1.19828 7.82898 1.24706 7.87611 1.30574C7.92356 1.36417 7.95899 1.4314 7.98037 1.50356C8.00176 1.57573 8.00866 1.65141 8.0007 1.72625C7.99274 1.8011 7.97006 1.87363 7.93398 1.93968C7.89789 2.00573 7.84911 2.064 7.79043 2.11114L4.3632 4.87006C4.261 4.95407 4.13279 5 4.00049 5C3.86818 5 3.73998 4.95407 3.63777 4.87006L0.210546 2.01403C0.152707 1.96608 0.104896 1.90719 0.0698514 1.84073C0.0348067 1.77427 0.0132165 1.70156 0.00631857 1.62674C-0.00057888 1.55193 0.0073514 1.47649 0.0296535 1.40474C0.0519562 1.333 0.0881925 1.26635 0.136289 1.20864C0.189442 1.14311 0.256451 1.09017 0.332499 1.05363C0.408547 1.01709 0.491746 0.997848 0.576117 0.99729Z"
                    fill="#9A9A9A"
                  ></path>
                </svg>
              </div>
              <div
                class="folder__drag-drop"
                v-if="project.open && project.lists.length == 0"
              >
                {{ $t("list.drag_drop_lists") }}
              </div>
              <draggable
                v-model="project.lists"
                group="list"
                class="folder__drag"
                v-if="project.open"
                @change="changeFolderList(project._id, $event)"
                v-bind="dragOptions"
              >
                <li
                  v-for="list in project.lists"
                  :key="list._id"
                  :ref="'project_' + list._id"
                  @click="SearchResultNull(list._id)"
                  @contextmenu.prevent="listContextMenu(list, false, $event)"
                >
                  <router-link
                    :to="linkLists(list._id)"
                    v-if="list._id != getUserData.shortcut_inbox"
                    class="li"
                    :data-list-id="list._id"
                  >
                    <div
                      style="display: flex; align-items: center"
                      class="list_body-content"
                    >
                      <div
                        v-if="getUserData.theme"
                        class="project_icon"
                        :style="
                          'background-color: ' +
                          $shiftPaletteHue(
                            list.color,
                            '#cb4646',
                            getUserData.theme.color
                          )
                        "
                      >
                        {{ list.name[0] }}
                      </div>
                      <ShortcutsIcon></ShortcutsIcon>
                      <div
                        class="project_name_body"
                        :data-id="list._id"
                        @dragover="onDragBgColor($event)"
                        @drop="onDragOver(list._id, $event)"
                        :class="
                          get_unreaded_messages_in_project[list._id] > 0
                            ? ''
                            : 'no_messages'
                        "
                      >
                        <div class="project_name" v-if="!list.rename">
                          {{ list.name }}
                        </div>
                        <div class="project_name" v-else>
                          <input
                            type="text"
                            v-model="list.name"
                            @keypress.enter="changeNameList_toFolder(list)"
                            @blur="changeNameList_toFolder(list)"
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="get_unreaded_messages_in_project[list._id] > 0"
                      class="unread"
                    >
                      <p
                        v-if="
                          getListsMentions[list._id] &&
                          getListsMentions[list._id].mentions > 0
                        "
                        class="unread__mention"
                      >
                        @
                      </p>
                      <p class="unread__count">
                        {{ unreaded_msg[list._id] }}
                      </p>
                    </div>
                  </router-link>
                </li>
              </draggable>
            </div>
          </li>
        </draggable>

        <li
          class="list_menu"
          @contextmenu.prevent="listContextMenu(false, true, $event)"
        ></li>
      </ul>
    </div>

    <ChatsLists v-if="tab == 'Chats'"></ChatsLists>
    <ListContextMenu v-if="show_list_context_menu"></ListContextMenu>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import draggable from "vuedraggable";
import { EventEmitter } from "../../main";

import AddProject from "@/components/projects/AddProject";
import NotFound from "@/components/app/NotFound";
import ChatsLists from "../chats/ChatsLists.vue";

import ListContextMenu from "./ListContextMenu.vue";
import ShortcutsIcon from "./ShortcutsIcon.vue";

export default {
  name: "ProjectsView",
  props: {
    toggleCollapse: [Boolean],
  },
  data() {
    return {
      hover: {},
      unreaded_msg: {},
      projects: [],
      last_chats: {},
      shortcuts: [],
      tab: "Lists",
      show_list_context_menu: false,
      folder_show: [],
      folder_name: "",
      lists: [],
      folders: [],
      folder_lists: [],
      delete_send_one: true,
      nowDay: new Date().getDate(),
      show: {
        chats: false,
        lists: false,
      },
      task_move_bool: true,
      task_move: "",
      task_length: [],
      unread_number: [],
      enumShortcuts: {
        Inbox: this.$t("app.shortcuts.inbox"),
        Today: this.$t("app.shortcuts.today"),
        "Assigned to me": this.$t("app.shortcuts.assigned_to_me"),
        "Medium priority": this.$t("app.shortcuts.medium_priority"),
        "High priority": this.$t("app.shortcuts.high_priority"),
      },
    };
  },
  methods: {
    ...mapActions(["delete_project", "render_lists", "change_lists_order"]),
    ...mapMutations([
      "setProjects",
      "setFolder",
      "setLists",
      "setMessage",
      "lists_order",
      "addTask",
      "removeTask",
      "setNumberOfTasks",
      "setSortedLists",
    ]),
    last_message_width() {
      this.getProjects.forEach((project) => {
        if (document.querySelector(`.li[data-list-id="${project._id}"]`)) {
          let unread_width = document.querySelector(
            `[data-list-id="${project._id}"] .unread`
          )
            ? document.querySelector(
                `.li[data-list-id="${project._id}"] .unread`
              ).clientWidth - 12
            : 0;
          document.querySelector(
            `.li[data-list-id="${project._id}"] .project_name`
          ).style.width = 200 - 65 - unread_width + "px";
        }
      });
    },
    renderAllProject() {
      let arr = [];
      let arrayListsFolder = [];

      arr["folder"] = [];
      arr["list"] = [];

      let projects = this.getProjects.filter(
        (e) => e._id != this.getUserData.shortcut_inbox
      );

      try {
        if (projects.length > 0) {
          projects.forEach((list, list_index) => {
            if (this.getUserData.folder.length > 0) {
              this.getUserData.folder.forEach((e) => {
                e.folder = true;
                e.open = false;
                e.lists.forEach((list_id, i) => {
                  if (list_id == list._id) {
                    e.lists[i] = "";
                    // delete list.sections
                    // delete list.tasks
                    // delete list.date
                    // delete list.__v
                    // delete list.author
                    // delete list.order_by
                    // list._id = list_index
                    e.lists[i] = list;
                    arrayListsFolder.push(list_id);
                  }
                });
                arr["folder"][e.order] = e;
              });
            } else {
              list.users.forEach((user) => {
                if (user._id == this.getUserData._id) {
                  // list.order = user.order
                  if (arr["list"][user.order]) {
                    if (arr["list"][user.order]._id != list._id) {
                      equalsOrderList.push(list);
                      arr["list"][Number(user.order) + list_index] = list;
                    }
                  } else {
                    arr["list"][user.order] = list;
                  }
                }
              });
            }

            const even = (e) => e == list._id;

            if (!arrayListsFolder.some(even)) {
              list.users.forEach((user) => {
                if (user._id == this.getUserData._id) {
                  // list.order = user.order
                  if (arr["list"][user.order]) {
                    equalsOrderList.push(list);
                    if (arr["list"][user.order]._id != list._id) {
                      arr["list"][Number(user.order) + list_index] = list;
                    }
                  } else {
                    arr["list"][user.order] = list;
                  }
                }
              });
            }
          });
        } else {
          if (this.getUserData.folder.length > 0) {
            this.getUserData.folder.forEach((e) => {
              e.folder = true;
              e.open = false;
              arr["folder"][e.order] = e;
            });
          }
        }

        // arr['list'].sort( function (a, b) {
        //     return a.order - b.order
        // })

        this.lists = arr["list"];
        this.folders = arr["folder"];
      } catch (error) {
        // console.log(error)
      }
    },
    project_name_thumbnail(name) {
      if (name) {
        let array_name = name.trim().replaceAll("-", "").split(" ");
        array_name = array_name.filter((e) => e != "");
        if (array_name.length >= 2) {
          return String(array_name[0])[0] + "" + String(array_name[1])[0];
        } else {
          return String(array_name[0])[0];
        }
      }
    },
    projectScroll() {
      setTimeout(() => {
        if (document.querySelector(".projects")) {
          if (
            document.querySelector(".lists_block") &&
            document.querySelector(".folder__lists")
          ) {
            let height_project =
              document.querySelector(".projects").clientHeight;
            let height_lists =
              document.querySelector(".lists_block").clientHeight;
            let folder__lists =
              document.querySelector(".folder__lists").clientHeight;

            if (height_project > height_lists + folder__lists) {
              document.querySelector(".lists").classList.add("no-scroll");
            } else {
              document.querySelector(".lists").classList.remove("no-scroll");
            }
          }
          if (document.querySelector(".chats")) {
            let height_project =
              document.querySelector(".projects").clientHeight;
            let height_chats = document.querySelector(".chats").clientHeight;

            if (height_project > height_chats) {
              document.querySelector(".chats").classList.add("no-scroll");
            } else {
              document.querySelector(".chats").classList.remove("no-scroll");
            }
          }
        }
      }, 10);
    },
    linkLists(list_id) {
      // alert(list_id)
      // localStorage.setItem('project_id', list_id)
      return "/project/" + list_id;
    },
    onDragBgColor(e) {
      document.querySelectorAll(".move-task").forEach((element) => {
        element.classList.remove("move-task");
      });
      e.srcElement.closest("li a").classList.add("move-task");
    },
    onDragOver(id, e) {
      if (this.task_move) {
        if (this.task_move_bool) {
          if (id != this.task_move.project_id) {
            let a = false;

            this.$w_plan(
              this,
              this.getPlan,
              "task",
              () => {
                this.setMessage({
                  key_message: "warning",
                  message: this.$planMessages.task.en,
                  plan: true,
                });
                a = true;
              },
              id
            );

            if (a) {
              return;
            }

            const tasks = [];

            this.getTasks[id].forEach((e) => {
              if (e) {
                if (!e.parent && !e.section) {
                  tasks.push(e);
                }
              }
            });

            tasks.sort(function (a, b) {
              return a.order - b.order;
            });

            this.task_move_bool = false;
            let subtasks = this.getSubTask.filter(
              (e) => e.parent == this.task_move.task_id
            );
            let array_subtask = [];

            subtasks.forEach((e) => {
              array_subtask.push(e._id);
            });

            let data = {
              remove_project_id: this.task_move.project_id,
              add_project_id: id,
              subtasks: array_subtask,
              task_id: this.task_move.task_id,
              order: tasks.length == 0 ? 0 : tasks.length + 1,
            };

            this.$store.dispatch("socket_move_task", data);

            EventEmitter.$emit("RemoveTaskSection", this.task_move);
            EventEmitter.$emit("TaskMove_DeleteTask", this.task_move.task_id);

            document.querySelectorAll(".move-task").forEach((element) => {
              element.classList.remove("move-task");
            });

            this.task_move = "";
          }
        }
      }
      document.querySelectorAll(".move-task").forEach((element) => {
        element.classList.remove("move-task");
      });
    },
    changeFolder(id, evt) {
      // console.log('changeFolder', evt)
      let list_id = [];
      this.lists.forEach((list) => {
        if (list._id == id) {
          list.lists.forEach((e) => {
            list_id.push(e._id);
          });
        }
      });
      this.$socket.emit("IN_AddList_toFolder", {
        folder_id: id,
        list_id: list_id,
      });
    },
    changeNameList(list) {
      ////////
      if (list.name != "" && list.name.length < 160) {
        this.lists.forEach((lists, i) => {
          if (lists._id == list._id) {
            this.lists[i].rename = false;
            this.lists[i].name = list.name;
          }
        });
        this.$socket.emit("IN_ProjectRename", {
          _id: list._id,
          name: list.name,
        });
      }
    },
    changeNameList_toFolder(data) {
      ////////
      this.folders.forEach((folder, folder_index) => {
        folder.lists.forEach((list, list_index) => {
          if (list._id == data._id) {
            this.folders[folder_index].lists[list_index].rename = false;
            this.folders[folder_index].lists[list_index].name = data.name;
          }
        });
      });
      this.$socket.emit("IN_ProjectRename", {
        _id: data._id,
        name: data.name,
      });
    },
    changeNameFolder(folder) {
      if (folder.name != "" && folder.name.length < 160) {
        this.folders.forEach((f, i) => {
          if (f._id == folder._id) {
            this.folders[i].rename = false;
            this.folders[i].name = folder.name;
          }
        });
        this.$socket.emit("IN_RenameFolder", {
          folder_id: folder._id,
          folder_name: folder.name,
        });
      }
    },
    blurFolderInput(folder_id) {
      this.folders.forEach((e, i) => {
        if (e._id == folder_id) {
          if (e.name == "" && this.folder_name == "") {
            this.folders.splice(i, 1);
          } else {
            this.createFolder(e);
          }
        }
      });
    },
    changeFolderList(folder_id) {
      this.folders.forEach((e, i) => {
        if (e._id == folder_id) {
          let list_id = [];

          e.lists.forEach((e) => {
            let data = list_id.filter((a) => a == e._id);
            if (data.length == 0) {
              list_id.push(e._id);
            }
          });

          this.$socket.emit("IN_AddList_toFolder", {
            folder_id: e._id,
            list_id: list_id,
          });
        }
      });
    },
    changeLists(evt) {
      document.querySelectorAll(".project_name_body").forEach((element) => {
        element.closest("li").classList.remove("hover");
      });

      let new_order_lists = [];
      let new_order_folder = [];

      this.folders.forEach((e, i) => {
        new_order_folder.push({
          _id: e._id,
          order: i,
        });
      });

      this.lists.forEach((e, i) => {
        new_order_lists.push({
          list_id: e._id,
          order: i,
        });
      });

      // if (!evt.removed) {
      this.lists_order({
        folder: this.folders,
        list: this.lists,
      });

      this.$socket.emit("IN_ChangeOrderLists", {
        new_order_lists: new_order_lists,
      });

      this.$socket.emit("IN_ChangeOrderFolder", {
        new_order_folder: new_order_folder,
      });
      // }

      // let data = []
      // data['list'] = this.lists
      // data['folder'] = this.folders

      // this.setLists(data)
    },
    renderOrderLists(type) {
      let lists = [];
      let folder_lists = [];
      if (type == "lists") {
        this.getLists.forEach((e, i) => {
          e.order = i;
          lists.push(e);
        });
        // console.log(lists)
        return lists;
      }
      if (type == "folder") {
        this.getUserData.folder.forEach((folder) => {
          folder_lists[folder._id] = [];
          this.getFolderLists[folder._id].forEach((e, i) => {
            e.order = i;
            folder_lists[folder._id].push(e);
          });
        });
        return folder_lists;
      }
    },
    createFolder(folder) {
      if (this.folder_name != "" && this.folder_name.length < 18) {
        this.$socket.emit("IN_CreateFolder", {
          _id: folder._id,
          name: this.folder_name,
          order: folder.order,
        });
        this.getUserData.folder.forEach((e, i) => {
          if (e.name == "") {
            this.getUserData.folder[i].name = this.folder_name;
            this.getUserData.folder[i].open = true;
            // console.log(this.folder_show)
            // this.folder_show.push({
            //     num: i,
            //     active: false
            // })
            // console.log(this.folder_show)
          }
        });
        this.folder_name = "";
      }
    },
    openFolder(list_id) {
      let folders = this.folders;
      folders.forEach((e, i) => {
        if (e._id == list_id) {
          folders[i].open = !folders[i].open;
          localStorage.setItem(`folder_${list_id}`, folders[i].open);
        }
      });
      this.folders = "";
      this.folders = folders;
      setTimeout(() => {
        this.last_message_width();
      }, 10);
      document.querySelector(".lists").classList.remove("no-scroll");
      this.projectScroll();
      // console.log(this.folder_show)
      // this.folder_show.forEach((e) => {
      //     if (e.num == i) {
      //         this.folder_show[i].active = !this.folder_show[i].active
      //     }
      // })
    },
    listContextMenu(data, bool, e) {
      e.stopPropagation();
      e.target.classList;

      let position_menu = {
        x: e.x,
        y: e.y,
        data: data,
        bool: bool,
        show: true,
      };
      setTimeout(() => {
        EventEmitter.$emit("listContextMenu_open", position_menu);
      }, 10);
      this.show_list_context_menu = true;
    },
    // nowDay() {
    //     let now = new Date()
    //     return now.getDate()
    // },
    renderUserData() {
      if (this.getUserData.shortcuts) {
        let shortcuts = this.getUserData.shortcuts;

        if (this.getUserData.shortcuts) {
          if (this.getUserData.shortcuts.length == 0) {
            this.show.lists = true;
          }
        }

        this.shortcuts = [];
        this.shortcuts = shortcuts;
      }
    },
    open(e) {
      if (e == "chats") {
        this.show.chats = !this.show.chats;
      } else if (e == "lists") {
        this.show.lists = !this.show.lists;
      }
    },
    show_popover(project) {
      this.$refs["project_" + project][0].classList.toggle("hover");
    },
    SearchResultNull(project_id) {
      // console.log(0)
      EventEmitter.$emit("SearchTasksProject", "");
      EventEmitter.$emit("SearchInputClear", true);
      EventEmitter.$emit("SectionProject", project_id);
    },
    setWidthMsgBody() {
      // setTimeout(() => {
      //     for (const pr_id in this.unreaded_msg) {
      //         if (Object.hasOwnProperty.call(this.unreaded_msg, pr_id)) {
      //             const pr_list_item = this.$refs[`project_${pr_id}`] ? this.$refs[`project_${pr_id}`][0] : null;
      //             if (pr_list_item) {
      //                 const pr_list_item_body = pr_list_item.querySelector(".project_name_body");
      //                 const msg = pr_list_item.querySelector(".unread_messages");
      //                 if (msg) {
      //                     const width = msg.clientWidth && msg.clientWidth != 0 ? msg.clientWidth : +window.getComputedStyle(msg).width.match(/\d*/)[0] + 1;
      //                     const margin = +window.getComputedStyle(msg).marginRight.match(/\d*/)[0];
      //                     if (msg) {
      //                         const count = 57 + width + margin;
      //                         pr_list_item_body.style.width = `calc(100% - ${count}px)`;
      //                     } else {
      //                         pr_list_item_body.style.width = `calc(100% - 50px)`;
      //                     }
      //                 }
      //             }
      //         }
      //     }
      // }, 500);
    },
    set_new_last_message() {
      //   setTimeout(() => {
      //     if (Object.keys(this.last_chats).length > 0) {
      //       for (const pr_id in this.last_chats) {
      //         if (Object.hasOwnProperty.call(this.last_chats, pr_id)) {
      //           const last_message = this.last_chats[pr_id];
      //           if (this.$refs[`project_${pr_id}`]) {
      //             const project = this.$refs[`project_${pr_id}`][0];
      //             if (project) {
      //                 const project_name_body = project.querySelector(".project_name_body");
      //                 let last_message_body;
      //                 if (project_name_body.querySelector(".last_comment_in_project")) {
      //                     last_message_body = project_name_body.querySelector(
      //                     ".last_comment_in_project"
      //                     );
      //                 } else {
      //                     last_message_body = document.createElement("div");
      //                     last_message_body.classList.add("last_comment_in_project");
      //                     project_name_body.insertAdjacentElement(
      //                     "beforeend",
      //                     last_message_body
      //                     );
      //                 }
      //                 if (last_message) {
      //                     console.log(last_message.last_chat, this.getUserData._id)
      //                     project_name_body.classList.remove("no_messages");
      //                     last_message_body.innerHTML = ` <p class="last_comment_in_project__user_name">
      //                     ${
      //                     last_message.last_chat.user_id == this.getUserData._id
      //                         ? "You"
      //                         : last_message.last_chat.user_name
      //                     }:
      //                 </p>
      //                 <p class="last_comment_in_project__comment_body">
      //                     ${last_message.last_chat.message}
      //                 </p>`;
      //                 } else {
      //                     last_message_body.innerHTML = "";
      //                     project_name_body.classList.add("no_messages");
      //                 }
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }, 100);
    },
  },
  async mounted() {
    document.querySelector("body").classList.remove("intropage");

    setTimeout(() => {
      this.projectScroll();

      this.lists = this.getLists["list"]
        ? this.getLists["list"].filter((e) => e._id != "")
        : [];
      this.folders = this.getLists["folder"]
        ? this.getLists["folder"].filter((e) => e != undefined)
        : [];

      if (this.getLists["folder"]) {
        let folders = this.folders;
        folders.forEach((e, i) => {
          folders[i].open =
            localStorage.getItem(`folder_${e._id}`) == "true" ? true : false;
        });
        this.folders = folders;
      }

      this.unread_number = this.get_unreaded_messages_in_project;
    }, 100);

    setTimeout(() => {
      this.last_message_width();
    }, 500);

    window.addEventListener(
      "resize",
      (event) => {
        this.projectScroll();
      },
      true
    );

    EventEmitter.$on("nowDate", (date) => {
      this.nowDay = date;
    });

    setTimeout(() => {
      this.renderUserData();
      if (this.getProjects.length == 0) {
        this.show.chats = true;
      }
      let new_arr = [];
      if (this.lists) {
        this.lists.forEach((e, i) => {
          if (e) {
            e.users.forEach((user, j) => {
              if (user._id == this.getUserData._id) {
                e.users[j].order = i;
              }
            });
            new_arr.push(e);
          }
        });
      }
      this.lists = new_arr;

      this.unreaded_msg = this.get_unreaded_messages_in_project;

      // if (this.getProjects.length > 0) {
      //     this.setWidthMsgBody();
      // }
    }, 50);

    if (this.getUserData.folder) {
      this.getUserData.folder.forEach((e, i) => {
        this.folder_show.push({
          num: i,
          active: false,
        });
        // if (e.lists) {
        //     if (e.lists.length > 0) {
        //         e.lists.forEach((list_id, a) => {
        //             this.getProjects.forEach((list) => {
        //                 if (list._id == list_id) {
        //                     this.getUserData.folder[i].lists.splice(a, 1)
        //                     this.getUserData.folder[i].lists.push(list)
        //                 }
        //             })
        //         })
        //     }
        // }
      });
      // console.log(this.folder_show)
    }

    EventEmitter.$on("TaskMove", (data) => {
      this.task_move = data;
    });

    EventEmitter.$on("RedirectLists", (id) => {
      // setTimeout(() => {
      if (this.$route.params.project_id == id) {
        let bool = true;
        if (this.getLists["list"]) {
          this.getLists["list"].forEach((e, i) => {
            if (e._id == id) {
              bool = false;
              if (this.getLists["list"][i + 1]) {
                this.$router
                  .push("/project/" + this.getLists["list"][i + 1]._id)
                  .catch(() => true);
              } else {
                if (this.getLists["list"][i - 1]) {
                  this.$router
                    .push("/project/" + this.getLists["list"][i - 1]._id)
                    .catch(() => true);
                } else {
                  this.$router.push("/no-lists").catch(() => true);
                }
              }
            }
          });
        }
        if (bool) {
          if (this.getLists["folder"]) {
            this.getLists["folder"].forEach((folder) => {
              folder.lists.forEach((list, i) => {
                if (list._id == id) {
                  if (folder.lists[i + 1]) {
                    this.$router
                      .push("/project/" + folder.lists[i + 1]._id)
                      .catch(() => true);
                  } else {
                    if (folder.lists[i - 1]) {
                      this.$router
                        .push("/project/" + folder.lists[i - 1]._id)
                        .catch(() => true);
                    } else {
                      if (this.getLists["list"].length > 0) {
                        this.$router
                          .push(
                            "/project/" +
                              this.getLists["list"][
                                this.getLists["list"].length - 1
                              ]._id
                          )
                          .catch(() => true);
                      } else {
                        this.$router.push("/no-lists").catch(() => true);
                      }
                    }
                  }
                }
              });
            });
          } else {
            // alert(1)
            this.$router.push("/no-lists").catch(() => true);
          }
        }
      }
      // }, 500)
    });

    EventEmitter.$on("renameList", (data) => {
      let bool = true;

      this.lists.forEach((list, i) => {
        if (list._id == data._id) {
          bool = false;
          this.lists[i].rename = true;
        }
      });

      if (bool) {
        this.folders.forEach((folder, folder_index) => {
          folder.lists.forEach((list, list_index) => {
            if (list._id == data._id) {
              this.folders[folder_index].lists[list_index].rename = true;
            }
          });
        });
      }

      setTimeout(() => {
        document.querySelector(".project_name input").focus();
      }, 500);
    });

    EventEmitter.$on("renameFolder", (data) => {
      this.folders.forEach((folder, i) => {
        if (folder._id == data._id) {
          this.folders[i].rename = true;
        }
      });
      setTimeout(() => {
        document.querySelector(".folder__flex input").focus();
      }, 500);
    });

    EventEmitter.$on("RequestServerRemoveLists", (data) => {
      // EventEmitter.$emit('RedirectLists', data._id)
      if (this.lists) {
        let lists = this.lists.filter((project) => project._id != data._id);
        // this.lists = []
        this.lists = lists;
      }
    });

    EventEmitter.$on("DeleteLists", (list_data) => {
      try {
        let data = list_data.data;
        let bool = list_data.bool;

        if (bool) {
          if (this.lists) {
            let lists = this.lists.filter((project) => project._id != data._id);
            let listsArray = [];
            let new_order_lists = [];

            lists.forEach((e, i) => {
              if (e.folder) {
                e.order = i;
              } else {
                e.users.forEach((user, index) => {
                  if (user._id == this.getUserData._id) {
                    e.users[index].order = i;
                  }
                });
              }
              listsArray[i] = [];
              listsArray[i] = e;
            });

            this.lists = listsArray;

            this.lists.forEach((e, i) => {
              new_order_lists.push({
                list_id: e._id,
                order: i,
              });
            });

            this.change_lists_order(new_order_lists);
          }
        } else {
          let folder_id = "";

          if (this.folders) {
            this.folders.forEach((folder, folder_index) => {
              folder.lists.forEach((list, list_index) => {
                if (list._id == data._id) {
                  folder_id = folder._id;
                  this.folders[folder_index].lists.splice(list_index, 1);
                }
              });
            });

            let list_id = [];

            this.folders.forEach((folder, folder_index) => {
              if (folder._id == folder_id) {
                folder.lists.forEach((list) => {
                  list_id.push(list._id);
                });
              }
            });

            this.$socket.emit("IN_AddList_toFolder", {
              folder_id: folder_id,
              list_id: list_id,
            });
          }
        }
      } catch (error) {
        console.log(error);
      }
    });

    EventEmitter.$on("listContextMenu_close", (data) => {
      this.show_list_context_menu = false;
    });

    if (window.location.href.split("/").indexOf("project") > -1) {
      this.tab = "Lists";
    }

    if (window.location.href.split("/").indexOf("chats") > -1) {
      this.tab = "Chats";
    }

    if (window.location.href.split("/").indexOf("shortcuts") > -1) {
      this.tab = "Lists";
    }

    this.last_chats = this.getLastChat;

    EventEmitter.$on("changeTab", (data) => {
      this.tab = data;
      setTimeout(() => {
        this.last_message_width();
      }, 10);
      this.projectScroll();
    });

    EventEmitter.$on("InboxAdd", (data) => {
      this.getUserData.shortcut_inbox = data;
    });
  },
  computed: {
    ...mapGetters([
      "getPlan",
      "getProjects",
      "getChats",
      "get_unreaded_messages_in_project",
      "get_flag_for_unreaded",
      "getLastChat",
      "get_flag_for_last_chat",
      "getUserData",
      "getRenderUserData",
      "getLists",
      "getFolderLists",
      "get_flag_for_tasks",
      "getTasks",
      "getSubTask",
      "getCompletedTasks",
      "get_change_shortcuts_render",
      "getListsMentions",
    ]),
    unread_list_number() {
      return this.$store.state.comments.unreaded_messages_in_tasks;
    },
    getToggleCollapse() {
      return this.toggleCollapse;
    },
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        removeCloneOnHide: true,
      };
    },
  },
  watch: {
    lists(value) {
      this.setSortedLists({ type: "lists", value });
    },
    folders(value) {
      this.setSortedLists({ type: "folders", value });
    },
    get_unreaded_messages_in_project(newVal) {
      this.unreaded_msg = newVal;
    },
    get_change_shortcuts_render() {
      setTimeout(() => {
        this.renderUserData();
      }, 500);
    },
    get_flag_for_tasks() {
      this.task_move_bool = true;
      setTimeout(() => {
        this.renderUserData();
      }, 100);
    },
    unreaded_msg(e) {
      this.last_message_width();
    },
    getRenderUserData() {
      setTimeout(() => {
        this.renderUserData();
        this.getUserData.folder.forEach((e, i) => {
          if (e.name == "") {
            this.folder_show.push({
              num: i,
              active: false,
            });
          }
        });
      }, 500);
    },
    $route(to) {
      setTimeout(() => {
        if (to.params.project_id) {
          let is_list = this.getProjects.filter(
            (e) => e._id == to.params.project_id
          );
          if (is_list.length == 0) {
            this.$router.push("/remove_list");
          }
        }
      }, 100);
    },
    getProjects(data) {
      if (Object.keys(this.unreaded_msg).length > 0) {
        this.setWidthMsgBody();
      }
    },
    get_flag_for_last_chat(e) {
      this.lists = this.getLists["list"].filter((e) => e._id != "");
      this.folders = this.getLists["folder"];

      let folders = this.folders;
      folders.forEach((e, i) => {
        folders[i].open =
          localStorage.getItem(`folder_${e._id}`) == "true" ? true : false;
        e.lists.forEach((s) => {
          this.lists = this.lists.filter((a) => a._id != s._id);
        });
      });
      this.folders = folders;
    },
    get_flag_for_unreaded(e) {
      setTimeout(() => {
        this.unreaded_msg = [];
        this.unreaded_msg = this.get_unreaded_messages_in_project;
      }, 1);
      if (this.getProjects.length > 0) {
        this.setWidthMsgBody();
      }
    },
    getToggleCollapse(e) {
      if (e) {
        this.set_new_last_message();
        this.setWidthMsgBody();
      }
    },
  },
  components: {
    AddProject,
    ChatsLists,
    ListContextMenu,
    draggable,
    NotFound,
    ShortcutsIcon,
  },
};
</script>
